var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.1716 24L12.6891 15.5175C11.908 14.7364 11.908 13.4701 12.6891 12.6891C13.4701 11.908 14.7364 11.908 15.5175 12.6891L24 21.1716L32.4825 12.6891C33.2635 11.908 34.5299 11.908 35.3109 12.6891C36.092 13.4701 36.092 14.7364 35.3109 15.5175L26.8284 24L35.3109 32.4825C36.092 33.2635 36.092 34.5299 35.3109 35.3109C34.5299 36.092 33.2635 36.092 32.4825 35.3109L24 26.8284L15.5175 35.3109C14.7364 36.092 13.4701 36.092 12.6891 35.3109C11.908 34.5299 11.908 33.2635 12.6891 32.4825L21.1716 24Z",
    fill: "#E52525"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.b36308f583d66b594da6f63dbe121b88.svg";
export { ForwardRef as ReactComponent };